import { useEffect } from 'react'
import {
  ListBookingCars,
  RegionsFilter,
  TaxiparkFilter,
  SelectedTaxipark,
} from '~/features/BookingCars/ListBookingCars'
import { viewerModel } from '~/entities/viewer'
import { pushFx } from '~/shared/lib/history'
import { useTaxiparkQueryParams } from '~/shared/lib/useTaxiparkQueryParams'
import { PageContainer } from '~/shared/ui/PageContainer'
import { YM_KEYS_ENUM, useEvents } from '~/shared/ui/YandexMetrika'
import { BackTitle } from './styled'
import { useRefreshPage } from './useRefreshPage'

type ListBookingCarsPageProps = {
  canBack?: boolean
}

export function ListBookingCarsPage({
  canBack = true,
}: ListBookingCarsPageProps) {
  const authenticated = viewerModel.useAuthenticated()
  const { ymEvent } = useEvents()

  const { xTaxiparkKeyQuery } = useTaxiparkQueryParams()
  const { refreshPage } = useRefreshPage()

  const pageContainerProps = canBack
    ? { canBack, backTitle: 'Аренда авто' }
    : { extraHeader: <BackTitle>Аренда авто</BackTitle> }

  useEffect(() => {
    ymEvent(
      authenticated
        ? YM_KEYS_ENUM.booking_cars_list_view_auth
        : YM_KEYS_ENUM.booking_cars_list_view_un_auth,
    )
  }, [authenticated, ymEvent])

  return (
    <PageContainer
      title='Аренда авто'
      canBack={canBack}
      preventScrollReset
      onBack={() => pushFx('/')}
      onRefreshPage={refreshPage}
      {...pageContainerProps}
      topContent={
        <div>
          <div style={{ marginBottom: '24px' }}>
            <RegionsFilter />
          </div>

          {xTaxiparkKeyQuery ? <SelectedTaxipark /> : <TaxiparkFilter />}
        </div>
      }
    >
      <ListBookingCars />
    </PageContainer>
  )
}
